webpackJsonp([8],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);

var _api = __webpack_require__(0);

$(function () {
    // window.animateTimeOut.getTimeOut(5000,1500,[$("#renewal"),$("#growth"),$("#company"),$("#clue")]);
    var tId = null;

    window.onScrollElement.dataHandle();

    window.onscroll = function () {
        var elementArry = window.onScrollElement.elementArry;
        var clientHeight = $(window).height();
        clearTimeout(tId);
        tId = setTimeout(function () {
            window.lazyLoad(clientHeight);
            elementArry.forEach(function (obj, i) {
                window.onScrollElement.onScrollAuto(obj, clientHeight);
            });
        }, 100);
    };
});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[1]);


// WEBPACK FOOTER //
// js/about.98a2fa.js